/**
 * メール確認待ちページ (Phase 3 — Figma 準拠).
 *
 * 登録後に遷移。確認メールの案内。
 * Figma: #24 (メール確認待ち), #73 (再送信完了)
 */

import { Link } from '@tanstack/react-router';
import { useEffect } from 'react';

export function EmailSentPage({ email }: { email: string | undefined }) {
  useEffect(() => {
    document.title = 'メール送信完了 - PetaCMS';
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8f7f6]">
      <div className="w-[400px] rounded-[12px] border border-[#edebe8] bg-white px-8 py-10 text-center">
        <h1 className="text-[28px] font-bold text-[#23221e]">PetaCMS</h1>
        <h2 className="mt-4 text-[16px] font-semibold text-[#23221e]">確認メールを送信しました</h2>
        <p className="mt-3 text-[14px] text-[#706d65]">
          {email ? (
            <>
              <span className="font-medium text-[#23221e]">{email}</span>{' '}
              に確認メールを送信しました。
            </>
          ) : (
            '登録メールアドレスに確認メールを送信しました。'
          )}
        </p>
        <p className="mt-2 text-[13px] text-[#706d65]">
          メール内のリンクをクリックして、アカウントを有効化してください。
        </p>

        <div className="mt-5 rounded-[6px] border-l-4 border-[#f59e0b] bg-[#fffbeb] p-3 text-[13px] text-[#92400e]">
          メールが届かない場合は、迷惑メールフォルダをご確認ください。
        </div>

        <div className="mt-6">
          <Link to="/login" className="text-[13px] font-medium text-[#3b82f6] hover:text-[#1d4ed8]">
            ログインページに戻る
          </Link>
        </div>
      </div>
    </div>
  );
}
